/**
 * Componentes pequenos e utilitários compartilhados entre as seções do Dashboard.
 * Ficam fora do arquivo principal para reduzir seu tamanho e permitir reuso.
 */

/** Card de métrica com valor grande no meio */
export function Tile({ label, value, hint, mono = true, accent, testid }) {
  return (
    <div className="border border-black p-4 bg-white" data-testid={testid}>
      <div className="overline text-zinc-500 mb-2">{label}</div>
      <div
        className={`${mono ? "font-mono" : "font-head font-black"} text-lg md:text-xl lg:text-2xl leading-none break-words`}
        style={accent ? { color: accent } : {}}
      >
        {value}
      </div>
      {hint && <div className="text-[11px] text-zinc-500 mt-2">{hint}</div>}
    </div>
  );
}

/** Formata período (start/end YYYY-MM-DD) em texto pt-BR curto */
export const fmtPeriod = (start, end) => {
  if (!start || !end) return "";
  const fmt = (s) => {
    const [y, m, d] = s.split("-");
    return `${d}/${m}/${y.slice(2)}`;
  };
  return `${fmt(start)} → ${fmt(end)}`;
};

export const RANGE_OPTIONS = [
  { value: "day", label: "Dia" },
  { value: "week", label: "Semana" },
  { value: "month", label: "Mês" },
  { value: "custom", label: "Personalizado" },
];

/** Filtro de período reutilizável (Dia/Semana/Mês/Personalizado) */
export function RangePicker({ value, onChange, custom, onCustomChange, testid }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testid}>
      {RANGE_OPTIONS.map((o) => (
        <button
          key={o.value}
          onClick={() => onChange(o.value)}
          className={`text-[11px] px-2.5 py-1 border rounded-md ${value === o.value ? "bg-black text-white border-black" : "bg-white border-zinc-300 hover:border-black"}`}
          data-testid={`${testid}-${o.value}`}
        >
          {o.label}
        </button>
      ))}
      {value === "custom" && (
        <div className="flex items-center gap-1">
          <input
            type="date"
            className="input !py-1 !text-xs !w-[130px]"
            value={custom.start}
            onChange={(e) => onCustomChange({ ...custom, start: e.target.value })}
            data-testid={`${testid}-start`}
          />
          <span className="text-xs text-zinc-500">→</span>
          <input
            type="date"
            className="input !py-1 !text-xs !w-[130px]"
            value={custom.end}
            onChange={(e) => onCustomChange({ ...custom, end: e.target.value })}
            data-testid={`${testid}-end`}
          />
        </div>
      )}
    </div>
  );
}

/** Calcula % de variação entre valor atual e anterior. Retorna null se prev=0. */
export const pctDelta = (curr, prev) => {
  if (!prev) return null;
  return ((curr - prev) / prev) * 100;
};
